module.exports = __webpack_public_path__ + "img/74_18.7e09636c.png";